import { render, staticRenderFns } from "./BriefReferenceUploadWrapper.vue?vue&type=template&id=14e848cc&scoped=true"
import script from "./BriefReferenceUploadWrapper.vue?vue&type=script&lang=js"
export * from "./BriefReferenceUploadWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e848cc",
  null
  
)

export default component.exports